module.exports = __webpack_public_path__ + "static/media/12.4b41c453.JPG";